import { render, staticRenderFns } from "./index.vue?vue&type=template&id=26dd33ab&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=26dd33ab&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=26dd33ab&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd33ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dd33ab')) {
      api.createRecord('26dd33ab', component.options)
    } else {
      api.reload('26dd33ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=26dd33ab&scoped=true&", function () {
      api.rerender('26dd33ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/investigate/statistical/index.vue"
export default component.exports